/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator(), model);
        InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the ECR image hash
     */
    starts_with: string;

}
